import React from "react";
import { useTranslation } from "react-i18next";
import MessageDialog from "./MessageDialog";
import DialogActionButton from "./DialogActionButton";

interface ErrorDialogProps {
  title: string;
  message: string;
  onClose: () => void;
}

const ErrorDialog: React.FC<ErrorDialogProps> = ({
  title,
  message,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <MessageDialog>
      <div className="space-y-6 text-center">
        <h2 className="text-[28px] font-semibold leading-tight text-[#F24848]">
          {t(title)}
        </h2>
        <p className="whitespace-pre-line text-sm leading-7 text-[#333333]">
          {t(message)}
        </p>
        <div className="flex justify-center">
          <div className="w-full max-w-[180px]">
            <DialogActionButton
              label={t("_generic._close", { defaultValue: "閉じる" })}
              onClick={onClose}
              variant="danger"
            />
          </div>
        </div>
      </div>
    </MessageDialog>
  );
};

export default ErrorDialog;
